import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";
import { useParams } from "react-router-dom";
import { Avatar, Box, Paper, Typography } from "@mui/material";
import { ListDivider } from "../../ui/ListStyles";
import TicketLables from "./TicketLables";
import { COLORS } from "../../ui/Theme";
import { useMainLayoutContext } from "../../context/MainLayoutContext";
import ReplyTicket from "./ReplyTicket";
import { CloudDownload } from "@mui/icons-material";
import Loading from "../../components/loader/Loading";
import TicketClosedMessage from "./TicketCloseMessage";

const SingleTicket = () => {
  const { fullname } = useMainLayoutContext();
  const { ticketId } = useParams();

  const { data, isLoading } = useSWR(`/support/ticket/${ticketId}`, fetchData, {
    dedupingInterval: 60000,
  });

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <Typography sx={{ fontSize: "20px" }}>{data?.title}</Typography>
          <Typography sx={{ fontSize: "12px", color: COLORS.GRAY }}>
            شماره تیکت: {data?.id}
          </Typography>

          <TicketLables data={data} />

          <ListDivider flexItem />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflowY: "auto",
              height: "600px",
              pb: "200px",
            }}
          >
            {data?.responses.map((msg, index) => (
              <Paper
                key={index}
                sx={{
                  border: `1px solid ${COLORS.SOFTGRAY}`,
                  p: "14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "400px",
                  alignSelf: !msg.is_staff ? "flex-start" : "flex-end",
                }}
              >
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  {msg.is_staff ? data.receiver : fullname + " (شما)"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    color: COLORS.GRAY,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      display: "flex",
                      gap: 0.5,
                    }}
                  >
                    <span>تاریخ</span>
                    <span>{msg.date}</span>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      display: "flex",
                      gap: 0.5,
                    }}
                  >
                    <span>ساعت</span>
                    <span> {msg.time}</span>
                  </Typography>
                </Box>
                <ListDivider flexItem />
                <Typography
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    wordWrap: "break-word",
                  }}
                >
                  {msg.text}
                </Typography>
                {msg.appendix && (
                  <Box
                    className={"btn btn-softblue"}
                    sx={{
                      border: `1px solid ${COLORS.BLUE}`,
                      width: "170px",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                    component="a"
                    href={msg.appendix}
                    download
                  >
                    <CloudDownload sx={{ width: "18px" }} />
                    <Typography
                      sx={{
                        fontSize: "12px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {/* {msg.appendix} */}
                      {msg.appendix.slice(
                        msg.appendix.length - 10,
                        msg.appendix.length
                      )}
                      ...
                    </Typography>
                    <Avatar
                      variant="square"
                      sx={{
                        borderRadius: "8px",
                        border: `1px solid ${COLORS.GRAY}`,
                      }}
                      src={msg.appendix}
                      width={35}
                      height={31}
                    />
                  </Box>
                )}
              </Paper>
            ))}
          </Box>

          <Box>
            {data.status === "closed" ? (
              <TicketClosedMessage />
            ) : (
              <ReplyTicket />
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default SingleTicket;
